import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, getInputFormattedDateFromString } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from './progress.js';
import RefundListItem from './refundListItem.js';
import { Paginator } from './paginator.js';
import SearchInvoice from '../components/searchInvoice.js';

function ClientRefundInfo(props){
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredRefunds, setFilteredRefunds] = useState(props.client.refunds);
  const [offset, setOffset] = useState(0);
  const [refunds, setRefunds] = useState(props.client.refunds);
  const [description, setDescription] = useState(null);
  const [amount, setAmount] = useState(0);
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  const [invoice, setInvoice] = useState(null);
  const [cancellation, setCancellation] = useState(0);
  const [transactionId, setTransactionId] = useState(null);
  const [createdDate, setCreatedDate] = useState(getInputFormattedDateFromString(Date.now()));
  const [bank, setBank] = useState(props.client.bank);
  const [bank_account, setBankAccount] = useState(props.client.bank_account);
  const [account_holder_name, setAccountHolderName] = useState(props.client.account_holder_name);
  const [ifsc_code, setIfsc] = useState(props.client.ifsc_code);
  const [currency, setCurrency] = useState(props.client.currency);

  let searchForm = useRef();

  const handleSearch = (event) => {
    const target = event.target;
    const value = target.value;
    const filtered = [];
    for(let i = 0;i<refunds.length;i++){
      if(value === undefined || value.trim() === '' || refunds[i].description.indexOf(value) >= 0 || refunds[i].updation_date.indexOf(value) >= 0 || refunds[i].amount.indexOf(value) >= 0 || refunds[i].refund_id.indexOf(value) >= 0){
        filtered.push(refunds[i]);
      }
    }
    setFilteredRefunds(filtered);
  }

  const handleSubmit = (event) =>{
    event.preventDefault();
    if(amount && parseInt(amount) > 0 && description && invoice && parseInt(amount) <= parseInt(invoice.paid) && bank && bank_account && account_holder_name && ifsc_code && transactionId){
      const formData = new FormData;
      formData.append('description', description);
      formData.append('task', "create");
      formData.append('client', props.id);
      formData.append('invoice', invoice.invoice_id);
      formData.append('amount', amount);
      formData.append('currency', currency);
      formData.append('cancellation', cancellation);
      formData.append('bank', bank);
      formData.append('bank_account', bank_account);
      formData.append('account_holder_name', account_holder_name);
      formData.append('ifsc_code', ifsc_code);
      formData.append('transactionId', transactionId);
      formData.append('notifySms', notifySms);
      formData.append('notifyMail', notifyMail);
      formData.append('createdDate', createdDate);
      formData.append('token', localStorage.getItem("token"));
      setLoading(true);
      axios.post(global.config.api_server+'refund',formData).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Refund Receipt Created');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
          setLoading(false);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Fields must have valid values');
      setLoading(false);
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  const resetSearch = (event) => {
    searchForm.current.reset();
    setSearch('');
    setFilteredRefunds(refunds);
  }

  const onPageChange = (index_start) => {
    setOffset(index_start);
  }  

  let createRefund = "";
  if(parseInt(localStorage.getItem("role")) >= 3){
    createRefund = <a href="#" className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#createRefundModal">
                  <span className="icon text-white-50">
                    <i className="fas fa-file"></i>
                  </span>
                  <span className="text">Add New Refund Receipt</span>
                </a>;
  }
  let total = 0;
  let counter = 0;
  let offsetCounter = 0;
  const paginated_refunds = [];
  for (const u of filteredRefunds) {
    total++;
    offsetCounter++;
    if (offsetCounter > offset && counter < global.config.items_per_page){
      counter++;
      paginated_refunds.push(u);
    }
  }
  let balance = 0;
  if(invoice && amount){
    balance = (parseFloat(invoice.amount) - (parseFloat(invoice.paid) + parseFloat(amount)));
  }else if (invoice){
    balance = (parseFloat(invoice.amount) - parseFloat(invoice.paid));
  }

  return(
    <div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          {createRefund}
          <form ref={searchForm} className="form-inline">
              <h6 className={'form-group mr-3 font-weight-bold text-'+theme()}>Client - Refund Receipts(s)</h6>
              <div className="form-group mr-3">
                <input type="search" label="search" className="form-control" placeholder="Search" onChange={handleSearch}/>
              </div>
              {search &&
              <div className="form-group mr-3">
                <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                  <span className="icon">
                    <i className="fas fa-times"></i>
                  </span>
                </a>
              </div>
              }
            </form>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Refund Receipt Id</th> 
                      <th>Additional Note</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Created On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginated_refunds.map(refund =>
                      <RefundListItem info={refund} key={refund.refund_id} type="client"/>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Paginator
                itemCount={total}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filteredRefunds.length}
                grandTotal={refunds.length}
                onClick={onPageChange.bind(this)}
              />
          </div>
        </div>
      </div>
      <div className="modal fade" id="createRefundModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="create-popup">Create Refund Receipt</h5>
              <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <SearchInvoice handleSubmit={(e) => { setInvoice(e); setCurrency(e.currency);}} client={props.id}></SearchInvoice>
                {invoice && 
                  <div>
                    <div class="row">
                      <div class="col-md-6">
                        <div className="form-group">
                          <label>Total Refund Amount (Less than or equal to: {invoice.paid}) *</label>
                          <input type="number" value={amount} maxLength="50" name="amount" className="form-control" id="amount" placeholder="Enter Total Refund Amount" onChange={(e) => setAmount(e.target.value)}/>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div className="form-group">
                          <label>Cancellation Charges *</label>
                          <input type="number" value={cancellation} maxLength="50" name="cancellation" className="form-control" id="cancellation" placeholder="Enter Cancellation Charges" onChange={(e) => setCancellation(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Currency *</label>
                            <select value={currency} name="currency" className="form-control" id="currency" onChange={(e) => setCurrency(e.target.value)}>
                              {global.config.currencies.split(",").map(c =>
                                <option value={c} key={c}>{c}</option>
                              )}
                            </select>
                          </div>
                          <div className="form-group">
                            <label>Bank *</label>
                            <input type="text" value={bank} maxLength="50" name="bank" className="form-control" id="bank" placeholder="Enter Bank Name" onChange={(e) => setBank(e.target.value)}/>
                          </div>
                          <div className="form-group">
                            <label>Account Number *</label>
                            <input type="text" value={bank_account} maxLength="50" name="bank_account" className="form-control" id="bank_account" placeholder="Enter Account Number" onChange={(e) => setBankAccount(e.target.value)}/>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Account Holder Name *</label>
                            <input type="text" value={account_holder_name} maxLength="50" name="account_holder_name" className="form-control" id="account_holder_name" placeholder="Enter Account Holder Name" onChange={(e) => setAccountHolderName(e.target.value)}/>
                          </div>
                          <div className="form-group">
                            <label>IFSC Code *</label>
                            <input type="text" value={ifsc_code} maxLength="15" name="ifsc_code" className="form-control" id="ifsc_code" placeholder="Enter IFSC Code" onChange={(e) => setIfsc(e.target.value)}/>
                          </div>
                          <div className="form-group">
                            <label>Transaction Id *</label>
                            <input type="text" value={transactionId} maxLength="50" name="transactionId" className="form-control" id="transactionId" placeholder="Enter Transaction  Id" onChange={(e) => setTransactionId(e.target.value)}/>
                          </div>
                        </div>
                      </div>
                    <div className="form-group">
                      <label>Additional Note</label>
                      <textarea maxLength="400" name="description" className="form-control textarea-lg" id="description" placeholder="Additional Note" onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="form-group">
                        <label>Created Date</label>
                        <input type="date" value={createdDate} maxLength="50" name="createdDate" className="form-control" id="createdDate" placeholder="Enter Created Date" onChange={(e) => setCreatedDate(e.target.value)}/>
                      </div>
                    <div className="form-group">
                      <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
                    </div>
                  </div>
                }
                {loading === true ? (
                  <Progress label='Creating..' small={true}/>
                ):null}
              </div>
              <div className="modal-footer">
                <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                <button className={'btn btn-'+theme()} type="button" onClick={handleSubmit}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientRefundInfo;